export const companiesAllowedToGenerateServiceOrderPDF = [1, 1000];
